// extracted by mini-css-extract-plugin
export default {"root":"StatusContainer_root__fXYUV"};